import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FlashMessage } from '@/types/flashMessage';

const initialState: FlashMessage = {
  body: '',
  isWarning: false,
};

const slice = createSlice({
  name: 'flashMessage',
  initialState,
  reducers: {
    set(_, action: PayloadAction<FlashMessage>) {
      return action.payload;
    },
    clear() {
      return initialState;
    },
  },
});

export const actions = slice.actions;
export default slice.reducer;
